import React, { PropTypes, Component } from 'react'
import styles from './styles'

export default class SummaryCell extends Component {
  static propTypes = {
    className: PropTypes.string,
    data: PropTypes.object,
    userId: PropTypes.string,
    projectId: PropTypes.string,
    taskId: PropTypes.string,
    weekDay: PropTypes.number,
    type: PropTypes.string,
    onRecordUpdate: PropTypes.func,
  };

  constructor (props, context) {
    super(props, context)
  }

  shouldComponentUpdate (nextProps) {
    return (
      this.props.data.text !== nextProps.data.text ||
      this.props.data.nTime !== nextProps.data.nTime ||
      this.props.data.oTime !== nextProps.data.oTime ||
      this.props.data.note !== nextProps.data.note ||
      this.props.data.type !== nextProps.data.type ||
      this.props.data.colType !== nextProps.data.colType ||
      this.props.data.rowType !== nextProps.data.rowType ||
      this.props.userId !== nextProps.userId ||
      this.props.projectId !== nextProps.projectId ||
      this.props.taskId !== nextProps.taskId ||
      this.props.weekDay !== nextProps.weekDay
    )
  }

  render () {
    const { data, className } = this.props
    const { nTime, oTime } = data

    return (
      <div className={className} >
        {nTime !== 0 ? <span className={styles.nTime}>{(nTime / 2.0).toFixed(1)}</span> : null}
        {oTime !== 0 ? <span className={styles.oTime}>{(oTime / 2.0).toFixed(1)}</span> : null}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/app/components/timesheet/cell/summaryCell.jsx